import React from 'react'
import { Link } from 'react-router-dom'

export default function ButtomRelatorio(props) {

    const backgroundColor = props.backgroundColor ? props.backgroundColor : 'l-amber';
    const icon = props.icon ? props.icon : 'zmdi zmdi-chart';

    return (
        <>
            <div class="col-lg-2 col-sm-6 col-md-6 col-xs-12 p-1">
                <Link style={{ textDecoration: 'none', color: 'white', height: '' }} to={props.location}>
                    <div class={`card ${backgroundColor}`} style={{ padding: 0 }}>
                        <div class="body text-white" style={{ padding: '' }}>
                            <h4 style={{ marginBottom: '0px', fontSize: '1.5rem' }} className='text-white'><i className={`zmdi ${icon}`} style={{ fontSize: '25px' }}></i> {props.titulo} </h4>
                            <span className=''> {props.subtitulo}</span>
                        </div>
                    </div>
                </Link>
            </div>
        </>
    )
}
